import React, {memo, useMemo} from 'react';
import PropTypes from 'prop-types';
import { Tag } from 'antd';
import SelectElementCmp from '@/utils/SelectElementCmp';
import NomenclaturesAreaTypeApiService from '@/modules/settings/services/NomenclaturesAreaTypeApiService';

const SelectFacilitiesType = ({ value, onChange, filters, isTemplate, ...props }) => {

  const currentValue = useMemo(() => {
    if (!isTemplate) {
      return Array.isArray(value) ? value.map(v => v._id || v) : undefined;
    }
    return typeof value === 'object' ? value?._id : value;
  }, [isTemplate, value]);

  return (
    <SelectElementCmp
      queryKey={'facilities-type-select-'}
      service={NomenclaturesAreaTypeApiService}
      includeValue={''}
      value={currentValue}
      onChange={onChange}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      mode={!isTemplate ? 'multiple' : ''}
      filters={filters}
      {...props}
    />
  );
};

SelectFacilitiesType.propTypes = {
  value: PropTypes.string || PropTypes.object,
  onChange: PropTypes.func,
  filters: PropTypes.object,
  establishments: PropTypes.array,
  currentSelection: PropTypes.array,
  areasTotal: PropTypes.number,
  setAreas: PropTypes.number,
  isTemplate: PropTypes.bool,
};
SelectFacilitiesType.defaultProps = {
  entity: {},
};

export default memo(SelectFacilitiesType);

const FacilitiesView = ({entity}) => {

  return (
    <div className="w-full">
      {entity?.areas?.length > 0
        ? (
          <div className="flex items-center justify-start flex-wrap gap-3">
            {entity?.areas.map(v => (
              <Tag key={v?._id}>{v.name}</Tag>
            ))}
          </div>
        ) : 'N/A'}
    </div>
  );
};

FacilitiesView.propTypes = {
  value: PropTypes.array,
  entity: PropTypes.object,
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {Array} value this is the value of the dataIndex of the table
 * @param {Object} form this is the value of the dataIndex of the table
 * @param {Object} entity this is the value of the dataIndex of the table
 * */
export const renderFacilities = (value, form, entity) => {

  return (
    <FacilitiesView value={value} entity={entity}/>
  );
};
